import { ProductStat } from "."

export class InventoryModel {
    mCreated: string
    mEsModified: string
    mId: number
    mModified: string
    mPackageId: string
    mPharmacyId: string
    mPkgName: string
    mInStock: boolean
    mPrice: number
    mOriginalPrice: number
    mProductId: string
    mProductName: string
    mStatus: string
    mStockAmount: number
    mCategory: string
    mLastUpdateBy: string
    mLastUpdateById: number
    mLastUpdateByName: string
    mIsDropShipping: boolean
    dropshippingPhars: string

    constructor(inventory: any) {
        this.mCreated = inventory?.mCreated || ''
        this.mEsModified = inventory?.mEsModified || ''
        this.mId = inventory?.mId || null
        this.mModified = inventory?.mModified || ''
        this.mPackageId = inventory?.mPackageId || ''
        this.mPharmacyId = inventory?.mPharmacyId || ''
        this.mPkgName = inventory?.mPkgName || ''
        this.mPrice = inventory?.mPrice || ''
        this.mOriginalPrice = inventory?.mOriginalPrice || ''
        this.mProductId = inventory?.mProductId || ''
        this.mProductName = inventory?.mProductName || ''
        this.mStatus = inventory?.mStatus || ''
        this.mStockAmount = inventory?.mStockAmount || ''
        this.mInStock = typeof inventory?.mInStock !== 'boolean' ? true : inventory?.mInStock
        this.mCategory = inventory?.mCategory || ''
        this.mLastUpdateBy = inventory?.mLastUpdateBy || ''
        this.mLastUpdateById = inventory?.mLastUpdateById || ''
        this.mLastUpdateByName = inventory?.mLastUpdateByName || ''
        this.mIsDropShipping = typeof inventory?.mIsDropShipping !== 'boolean' ? false : inventory?.mIsDropShipping
        this.dropshippingPhars = inventory?.dropshippingPhars || ''
    }
}

export class InventoryModelWithProductStat extends InventoryModel {
    productStat?: ProductStat

    constructor(inventory: any) {
        super(inventory)
        this.productStat = inventory?.productStat
    }
}

export class EsInventoryModel {
    mId: string;
    mPharmacyId: number;
    mProductId: string;
    mPharmacy: EsPharmacy;
    mData: EsPkgData[];
    mProduct: EsProduct;

    constructor(data: any) {
        this.mId = data.mId || null;
        this.mPharmacyId = data.mPharmacyId || null;
        this.mProductId = data.mProductId || null;
        this.mPharmacy = new EsPharmacy(data.mPharmacy);
        this.mData = data.mData.map((item: any) => new EsPkgData(item));
        this.mProduct = new EsProduct(data.mProduct);
    }
}

export class EsPkgData {
    mId: number;
    mStatus: string;
    mPrice: number;
    mPackageId: string;
    mEsModified: null;
    mInStock: boolean;

    constructor(data: any) {
        this.mId = data.mId || null;
        this.mStatus = data.mStatus || null;
        this.mPrice = data.mPrice || null;
        this.mPackageId = data.mPackageId || null;
        this.mEsModified = data.mEsModified || null;
        this.mInStock = data.mInStock || null;
    }
}

export class EsPharmacy {
    mId: number;
    mPharCode: string;
    mName: string;
    mStatus: string;
    mRateValue: number;
    mRateTimes: number;
    mIsDev: boolean;
    mGpp: string;
    mPharmacyRankingId: number;
    mSuccessRate: number;
    mPharmacyAddress: EsPharmacyAddress;

    constructor(data: any) {
        this.mId = data.mId || null;
        this.mPharCode = data.mPharCode || null;
        this.mName = data.mName || null;
        this.mStatus = data.mStatus || null;
        this.mRateValue = data.mRateValue || null;
        this.mRateTimes = data.mRateTimes || null;
        this.mIsDev = data.mIsDev || null;
        this.mGpp = data.mGpp || null;
        this.mPharmacyRankingId = data.mPharmacyRankingId || null;
        this.mSuccessRate = data.mSuccessRate || null;
        this.mPharmacyAddress = new EsPharmacyAddress(data.mPharmacyAddress) || null;
    }
}

export class EsPharmacyAddress {
    mId: number;
    mType: null;
    mCreated: Date;
    mModified: Date;
    mAddress: string;
    mBelongToId: number;
    mAdministrativeAreaLevel3: string;
    mAdministrativeAreaLevel2: string;
    mAdministrativeAreaLevel1: string;
    mCountry: string;

    constructor(data: any) {
        this.mId = data.mId || null;
        this.mType = data.mType || null;
        this.mCreated = data.mCreated || null;
        this.mModified = data.mModified || null;
        this.mAddress = data.mAddress || null;
        this.mBelongToId = data.mBelongToId || null;
        this.mAdministrativeAreaLevel3 = data.mAdministrativeAreaLevel3 || null;
        this.mAdministrativeAreaLevel2 = data.mAdministrativeAreaLevel2 || null;
        this.mAdministrativeAreaLevel1 = data.mAdministrativeAreaLevel1 || null;
        this.mCountry = data.mCountry || null;
    }
}

export class EsProduct {
    dong_goi: DongGoi[];
    id: string;
    imageUrls: string[];
    name: string;
    pageUrl: string;
    product_status: string;
    category: string;

    constructor(data: any) {
        this.dong_goi = data.dong_goi ? data.dong_goi.map((item: any) => new DongGoi(item)) : null;
        this.id = data.id || null;
        this.imageUrls = data.imageUrls || null;
        this.name = data.name || null;
        this.pageUrl = data.pageUrl || null;
        this.product_status = data.product_status || null;
        this.category = data.category || null;
    }
}

export class DongGoi {
    duoc_ban_le: boolean;
    so_luong: number;
    don_vi: DonVi;
    loai_dong_goi: DonVi;
    id: string;

    constructor(data: any) {
        this.duoc_ban_le = data.duoc_ban_le || null;
        this.so_luong = data.so_luong || null;
        this.don_vi = new DonVi(data.don_vi);
        this.loai_dong_goi = new DonVi(data.loai_dong_goi);
        this.id = data.id || null;
    }
}

export class DonVi {
    name: string;
    id: string;

    constructor(data: any) {
        this.name = data.name || null;
        this.id = data.id || null;
    }
}
